import { ProfileOverview, type AreaLink } from '@kanos/web-core';
import { createFileRoute, Link } from '@tanstack/react-router';
import { FirmProfileTiles } from '../firm/profile-tiles';
import { useMe } from '../me';

export const Route = createFileRoute('/profile/')({
  component: Overview,
});

const link: AreaLink = (area, content, className) => (
  <Link to="/profile/$" params={{ _splat: area }} className={className}>
    {content}
  </Link>
);

/** The own profile at a glance, with the firm app's own tiles (after Corly). */
function Overview() {
  return <ProfileOverview me={useMe()} link={link} tiles={<FirmProfileTiles link={link} />} />;
}
